<template>
  <div class="flex flex-col gap-2 overflow-hidden flex-grow">

    <!-- icons -->
    <TRToolbar class="flex-shrink-0 flex items-center justify-between">
      <div class="flex space-x-2">
        <TRButton class="min-w-[130px] p-1" text="Favoriten anzeigen" :icon-position="'left'" icon="fa-solid fa-star"
                  @click="showFavoritePictures"/>
        <TRButton class="min-w-[130px]" text="Bild im Finder anzeigen" :icon-position="'left'" icon="fa-solid fa-images"
                  @click="openAndHighlightFileInFinder"/>
        <TRButton class="min-w-[130px]" text="Bild in Photoshop öffnen" :icon-position="'left'"
                  icon="fa-regular fa-images" @click="openInPhotoshop"/>
        <TRButton class="min-w-[130px]" text="Bild runterladen" :icon-position="'left'"
                  icon="fa-solid fa-file-arrow-down"
                  @click="startImageDownload($event, pictureData)"/>
        <TRButton class="min-w-[130px]" text="Artikel" :icon-position="'left'" icon="fa-solid fa-newspaper"
                  @click="openArticleWindow"/>
        <TRButton class="min-w-[130px]" text="Import" :icon-position="'left'" icon="fa-solid fa-file-export"
                  @click="exportImages"/>
      </div>

      <span v-if="!serverIsMounted" class="cursor-pointer text-trader-red text-sm font-bold"
            title="die Bilder sind wahrscheinlich nicht gemountet weswegen einzelne funktionen nicht Funktionieren werden">
        <i class="fa-solid fa-triangle-exclamation"></i> Server nicht gemountet
      </span>
    </TRToolbar>


    <Spinner v-if="showSpinner"></Spinner>

    <!-- Toolbar / Header  --->
    <div class="flex flex-shrink-0 flex-col gap-2  electron:px-2">


      <!-- Suchleiste -->

      <div class="flex gap-2 ">
        <TRButton icon="fa-solid fa-magnifying-glass" icon-position="left" text="Suchen"
                  @click="searchWithTerm(searchTerm)"/>
        <TRInput :focus-after-clear="true" class="bg-trader-dark-gray p-1 rounded" type="gray" placeholder="Suche..."
                 @keyup.enter="searchWithTerm(searchTerm)"
                 v-model="searchTerm"/>
        <TRSelect class="bg-trader-dark-gray p-1 rounded flex-grow" :options="selectOptions"
                  v-model="selectSearchOption"></TRSelect>
      </div>
      <div class="flex gap-2">
        <TRButton :selected="searchType == 'nonFood'" text="NonFood" @click="searchForNonFood()"/>
        <TRButton :selected="searchType == 'food'" text="Food " @click="searchForFood()"/>
        <TRContainer :direction="'row'" class="items-center gap-2" @click="toggleCheckbox">
          <input type="checkbox" ref="myCheckbox" @click="toggleCheckbox"/>
          <p>nicht im Go2Pict</p>
        </TRContainer>
        <TRContainer :direction="'row'" class="items-center gap-2" @click="addToArticleNumberToMainArticle">
          <input type="checkbox" ref="addToArticleScheckBox" @click="addToArticleNumberToMainArticle"/>
          <p>Artikel Nummern aud Dateinamen</p>
        </TRContainer>

      </div>
    </div>


    <!--BODY -->
    <div class="flex-grow flex gap-2 overflow-hidden electron:px-2">

      <!-- Suchbegriffe -->
      <!--
      <TRContainer title="Suchhistorie" class="w-[100px] flex-shrink-0" :scrollable="true">
        <div class="flex flex-col gap-2 ">
          <p class="border-b border-trader-light-gray hover:bg-trader-blue cursor-pointer hover:text-white dark:hover:text-black"
             v-for="searchTerm in searchTerms"
             @click="searchWithTerm(searchTerm)">{{ searchTerm }}</p>
        </div>
      </TRContainer>
      -->

      <!--Table -->
      <div class="flex flex-col flex-grow overflow-hidden gap-2">
        <TRTable :open-picture="true" :dataRows="tableData" :header="header" :on-selection-change="onSelectionChange">
          <template #cell="{ row, field, selected }">
            <div class="p-1" @click="editImageFavorite(row)" v-if="field === 'isInFavorite'">
              <i :class="row.isInFavorite ? 'fa-solid fa-star  text-yellow-300' : 'fa-regular fa-star'"></i>
            </div>
            <div v-else class="overflow-hidden whitespace-nowrap text-ellipsis "
                 v-html="formatCellValue(row, field, selected)">
            </div>
          </template>
        </TRTable>
        <TRTablePager :numberOfData="numberOfPictures" :on-page-step="onPageStep" :data-length="tableData.length"/>

      </div>

      <!--picture -->
      <div class="flex flex-col flex-shrink-0 w-[300px]  overflow-hidden gap-2">

        <!-- picture -->
        <TRContainer title="Bildvorschau" scrollable class="h-[300px] w-[300px] gap-2 overflow-hidden flex-shrink-0">
          <p v-if="!pictureIsMounted" class="text-trader-red font-bold w-full text-center">BIld ist nicht gemounted</p>

          <div v-if="picturesData.length == 1" class="flex h-full  w-full" @dragstart="onDragStart($event,pictureData)">
            <template v-for="(picture, index) in picturesData" :key="picture.id">
              <img v-if="picture?.imgLocNewFilepath" class="w-full h-full object-contain"
                   :src="picture?.imgLocNewFilepath" alt="">
            </template>
          </div>
          <div v-if="picturesData.length == 2" class="flex h-full gap-1 w-full">
            <template v-for="(picture, index) in picturesData" :key="picture.id" @dragstart="onDragStart($event,pictureData)">
              <img v-if="picture?.imgLocNewFilepath" class="w-1/2 h-full object-contain"
                   :src="picture?.imgLocNewFilepath" alt=""
                   @dragstart="onDragStart($event,picture)">
            </template>
          </div>
          <div v-if="picturesData.length == 3" class="flex h-full gap-1 w-full">
            <template v-for="(picture, index) in picturesData" :key="picture.id" @dragstart="onDragStart($event,pictureData)">
              <img v-if="picture?.imgLocNewFilepath" class="w-1/3 h-full object-contain"
                   :src="picture?.imgLocNewFilepath" alt=""
                   @dragstart="onDragStart($event,picture)">
            </template>
          </div>
          <div v-if="picturesData.length == 4" class="grid grid-cols-2 gap-1 h-full w-full" @dragstart="onDragStart($event,pictureData)">
            <template v-for="(picture, index) in picturesData" :key="picture.id">
              <div class="flex items-center bg-trader-light-gray justify-center overflow-hidden">
                <img v-if="picture?.imgLocNewFilepath"
                     class="object-contain max-w-full max-h-full"
                     :src="picture?.imgLocNewFilepath"
                     alt=""
                     @dragstart="onDragStart($event, picture)">
              </div>
            </template>
          </div>
          <div v-if="picturesData.length == 5 || picturesData.length == 6" class="grid grid-cols-3 gap-1 h-full w-full" @dragstart="onDragStart($event,pictureData)">
            <template v-for="(picture, index) in picturesData" :key="picture.id">
              <div class="flex items-center bg-trader-light-gray justify-center overflow-hidden">
                <img v-if="picture?.imgLocNewFilepath"
                     class="object-contain max-w-full max-h-full"
                     :src="picture?.imgLocNewFilepath"
                     alt=""
                     @dragstart="onDragStart($event, picture)">
              </div>
            </template>
          </div>
          <div v-if="picturesData.length <= 9 && picturesData.length >= 7" @dragstart="onDragStart($event,pictureData)"
               class="grid grid-cols-3 overflow-auto gap-1 h-full w-full">
            <template v-for="(picture, index) in picturesData" :key="picture.id">
              <div class="flex items-center bg-trader-light-gray justify-center overflow-hidden">
                <img v-if="picture?.imgLocNewFilepath"
                     class="object-contain max-w-full max-h-full"
                     :src="picture?.imgLocNewFilepath"
                     alt=""
                     @dragstart="onDragStart($event, picture)">
              </div>
            </template>
          </div>
          <div v-if="picturesData.length > 9" class="grid grid-cols-3 overflow-auto gap-1 h-full w-full" @dragstart="onDragStart($event,pictureData)">
            <template v-for="(picture, index) in picturesData" :key="picture.id">
              <div class="flex items-center bg-trader-light-gray justify-center ">
                <img v-if="picture?.imgLocNewFilepath"
                     class="object-contain max-w-full max-h-full"
                     :src="picture?.imgLocNewFilepath"
                     alt=""
                     @dragstart="onDragStart($event, picture)">
              </div>
            </template>
          </div>



        </TRContainer>
        <!-- picture information -->
        <TRContainer title="Bildinformationen" :scrollable="true" class="flex-grow">
          <div class="w-full flex flex-col">
            <div class="p-2">
              <p class="w-1/2 p-1 ">Artikelnummer</p>
              <div class="flex w-full border-b border-trader-light-gray gap-1 items-center">
                <div class="grid w-full grid-cols-5 gap-1  ">
                  <div
                      class="flex justify-center items-center text-center hover:bg-trader-blue cursor-pointer hover:text-white "
                      :class="{ 'bg-trader-blue': selectedArticleNumber == articleNumber }"
                      @click="openNewArticleWindow(articleNumber)" v-for="articleNumber in articleNumbers"
                      :key="articleNumber">{{ articleNumber }}
                  </div>
                </div>
              </div>
            </div>
            <div class="flex w-full border-b border-trader-light-gray p-2 ">
              <p class="w-1/2 ">Dateigröße</p>
              <span v-if="pictureData.imgLocMainFileSize">{{ formatBytes(pictureData.imgLocMainFileSize) }}</span>
            </div>
            <div class="flex w-full border-b border-trader-light-gray p-2 ">
              <p class="w-1/2 ">Auflösung</p>
              <span>{{ pictureData.imgLocImagDpiOrg }}</span>
            </div>
            <div class="flex w-full border-b border-trader-light-gray p-2 ">
              <p class="w-1/2 ">Pixelgröße</p>
              <span v-if="pictureData.imgLocImagWithOrg"> {{
                  pictureData.imgLocImagWithOrg
                }} * {{ pictureData.imgLocImagHightOrg }} </span>
            </div>
            <div class="flex w-full border-b border-trader-light-gray p-2 ">
              <p class="w-1/2 ">Änderungsdatum</p>
              <span>{{ pictureData?.imgLocFileModDate }}</span>
            </div>
            <div class="flex w-full border-b border-trader-light-gray p-2">
              <p class="w-1/2">OriginalPfad</p>
              <span class="break-words w-1/2">{{ pictureData?.imgLocOrgFilepath }}</span>
            </div>
            <div class="flex w-full border-b border-trader-light-gray p-2">
              <p class="w-1/2">Originalname</p>
              <span class="break-words w-1/2">{{ pictureData?.imgLocOrgFilename }}</span>
            </div>
            <div class="flex w-full border-b border-trader-light-gray p-2">
              <p class="w-1/2">Neuer Pfad</p>
              <span class="break-words w-1/2">{{ pictureData?.imgLocNewFilepath }}</span>
            </div>
            <div class="flex w-full p-2">
              <p class="w-1/2">Neuer Name</p>
              <span class="break-words w-1/2">{{ pictureData?.imgLocNewFilename }}</span>
            </div>
          </div>
        </TRContainer>
      </div>
    </div>

    <div class=" flex w-full gap-2 flex-shrink-0 h-[250px] electron:px-2 electron:pb-2 ">
      <!-- Importklasse -->
      <TRContainer class="flex flex-col w-[200px] flex-shrink-0 " title="Importklasse">

        <TRButton :padding="1" @click="updateImageClass" text="speichern"></TRButton>
        <div class="overflow-hidden gap-2 flex flex-col   flex-grow">
          <TRListe :data-list="importClass" :on-selection-change="getImgLocGo2pictClass"
                   :selected-id="pictureData.IMGLocGo2pictClass"></TRListe>
        </div>
      </TRContainer>

      <!-- EK-Bereiche -->
      <TRContainer class="flex-grow flex-shrink-0" title="EK-Bereiche" direction="column">
        <div class="flex gap-2">
          <TRButton :padding="1" @click="resetSearch" icon="fa-solid fa-xmark" icon-position="left"
                    text="Alle anzeigen"/>
          <!-- kann man eigentlich entferen er filter ja immer dirket  -->
          <TRButton :padding="1" icon="fa-solid fa-magnifying-glass" icon-position="left" text="Suchen"/>
          <TRInput class="bg-trader-dark-gray p-1 rounded " type="gray" placeholder="Suche..."
                   v-model="searchPurchaser"/>
          <TRButton :padding="1" @click="updatePurchaser" text="speichern"></TRButton>
        </div>
        <div class="overflow-hidden  flex-grow">
          <TRListe :data-list="purchaserCell" :on-selection-change="getPurchaserId"
                   :selected-id="pictureData.purchaserID" :search-input="searchPurchaser"></TRListe>
        </div>

      </TRContainer>
    </div>
  </div>


</template>

<script setup lang="ts">
import {mutation, query} from "@/graphql";
import {onMounted, ref} from "vue";
import TRTable from "@/components/Base/TRTable.vue";
import TRTablePager from "@/components/Base/TRTablePager.vue";
import {electron} from "@/electron";
import TRButton from "@/components/Base/v2/TRButton.vue";
import TRInput from "@/components/Base/v2/TRInput.vue";
import TRSelect from "@/components/Base/v2/TRSelect.vue";
import TRContainer from "@/components/Base/v2/TRContainer.vue";
import TRToolbar from "@/components/Base/v2/TRToolbar.vue";
import TRListe from "@/components/Base/v2/TRListe.vue";
import Spinner from "@/components/Base/Spinner.vue";


//imgLocFileModDate imgLocMarkedForDeletion imgLocMainFileSize imgLocNewFilename
// Änderungsdatum Löschen Bildgröße  Bildname go2Trade
const header = [
  {title: "#", field: "isInFavorite", width: 50},
  {title: "Bildname auf dem Server", field: "imgLocOrgFilepath", width: null},
  {title: "Änderungsdatum", field: "imgLocFileModDate", width: 200},
  {title: "Löschen", field: "imgLocMarkedForDeletion", width: 80},
  {title: "Bildgröße", field: "imgLocMainFileSize", width: 80},
  {title: "Bildname go2Trade", field: "imgLocNewFilename", width: 200},
];

const selectOptions = [
  {value: 0, label: 'Im Namen oder in Artikelnummer'},
  {value: 1, label: 'Im Pfad'},
  {value: 2, label: 'Go2Pict ID'},
  {value: 3, label: 'Ist nicht im Namen oder Pfad'},
  {value: 4, label: 'In Artikelnummer'},
  {value: 5, label: 'In Einkaufsbereich'},
  {value: 6, label: 'In Warengruppe'},
  {value: 7, label: 'Im original Pfad'},
];
const selectedArticleNumber = ref("");
const articleNumbers = ref([]);
const purchaserCell = ref([]);
const searchPurchaser = ref("");
const searchType = ref("");
const myCheckbox = ref(null)
const addToArticleScheckBox = ref(null);
const searchWithNumber = ref(false);
let addToArticle = ref(false);
let showSpinner = ref(false);
let purchaserId = ref(0);
let imgLocGo2pictClass = ref(0);
const picturesData = ref({});
const pictureData = ref({});
const searchTerm = ref("");
const searchTerms = ref([]);
const tableData = ref([]);
const showFavorite = ref(false);
const numberOfPictures = ref(0);
const count = ref(1);
const selectSearchOption = ref(0);
let articleNumber = ref("");
const purchasers = ref("");
const importClass = ref([]);
const serverIsMounted = ref(true);
const pictureIsMounted = ref(true);

function addToArticleNumberToMainArticle() {
  addToArticle.value = !addToArticle.value;
  const checkbox = addToArticleScheckBox.value; // Zugriff auf die Checkbox
  if (checkbox) {
    checkbox.checked = !checkbox.checked; // Checkbox toggeln

  }
}

function searchWithOutArticleNumber(isChecked) {
  searchWithNumber.value = isChecked;
  loadData();
}

async function exportImages() {
  try {
    showSpinner.value = true;

    let exportImages = []

    picturesData.value.forEach(image => {
      exportImages.push({
        imgLocNewFilename: image.imgLocNewFilename,
        imgLocID: image.imgLocID,
        imgLocProductName: image.imgLocProductName,
      })
    })

    const [data, err] = await mutation.exportImages(exportImages, addToArticle.value);
    if (err) {
      console.error(err);
    }
  } catch (e) {
    console.error(e);
  } finally {
    showSpinner.value = false;
    await loadData();
  }

}

function toggleCheckbox() {
  const checkbox = myCheckbox.value; // Zugriff auf die Checkbox
  if (checkbox) {
    checkbox.checked = !checkbox.checked; // Checkbox toggeln
    searchWithOutArticleNumber(checkbox.checked); // Funktion mit aktuellem Zustand aufrufen
  }
}

async function updateImageClass() {

  const imgIds = [];
  const pictureIds = [];
  picturesData.value.forEach((image) => {
    imgIds.push(image.imgLocID);
    pictureIds.push(image.imgLocGo2pictIDPicture);
  });

  const [data, err] = await mutation.editImagesClass(imgIds, imgLocGo2pictClass.value, pictureIds);
  if (err) {
    console.error(err);
  }
  await loadData();
}


function getImgLocGo2pictClass(importClass) {
  imgLocGo2pictClass.value = importClass.id;
}

function searchForFood() {
  if (searchType.value === "food") {
    searchType.value = "";
  } else {
    searchType.value = "food";
  }

  loadData();
}


function searchForNonFood() {
  if (searchType.value === "nonFood") {
    searchType.value = "";
  } else {
    searchType.value = "nonFood";
  }
  loadData();
}

async function editImageFavorite(row) {
  let imgLocID = row.imgLocID;
  row.isInFavorite = !row.isInFavorite;
  let isInFavorite = !row?.isInFavorite;
  const [data, err] = await mutation.editImageFavorite(imgLocID, isInFavorite);
  if (err) {
    console.error(err);
  }
}

async function updatePurchaser() {

  const imgIds = [];
  const productIds = [];

  picturesData.value.forEach((image) => {
    imgIds.push(image.imgLocID);
    productIds.push(image.imgLocGo2pictIDProductPic);

  });

  const [data, err] = await mutation.editImagesPurchaser(imgIds, purchaserId.value, productIds);
  if (err) {
    console.error(err);
  }
  await loadData();


}

function getPurchaserId(purchaser) {
  purchaserId.value = purchaser.id;
}


function resetSearch() {
  searchPurchaser.value = "";


}


function formatCellValue(row, field, selected) {
  let value = row[field];

  let textColor = "";
  let fontWeight = "";

  // Neue Regel: Schriftgewicht basierend auf imgLocArticleNumber
  if (row.imgLocArticleNumber == null || row.imgLocArticleNumber === "") {
    fontWeight = "font-normal";
  } else {
    fontWeight = "font-bold";
  }

  // Neue Regel: Textfarbe basierend auf imgLocGo2pict
  if (row.imgLocGo2pict == "0") {
    textColor = "text-red-500";
  } else {
    // Wenn textColor noch nicht gesetzt ist, Standardfarbe verwenden
    textColor = "text-trader-text";

    if (selected) {
      textColor = "text-trader-highlight";
    }
  }

  // Zusätzliche Formatierungen für bestimmte Felder
  if (field === "imgLocMarkedForDeletion") {
    value = value.toLowerCase() === "yes" ? "Ja" : "Nein";
  } else if (field === "imgLocMainFileSize") {
    value = formatBytes(value);
  }

  // Kombiniere die Stile
  let style = [textColor, fontWeight].filter(Boolean).join(' ').trim();

  return '<span class="' + style + '">' + value + '</span>';
}


function showFavoritePictures() {
  showFavorite.value = !showFavorite.value;
  if (showFavorite.value) {
    tableData.value = tableData.value.filter((item) => item.isInFavorite);
  } else {
    loadData();
  }
}

async function getImportClass() {
  const [data, err] = await query.getImportClass();

  data?.forEach((item) => {
    importClass.value.push({value: item.pictureClass, id: item.idPictureClass});
  });
  if (err) {
    console.error(err);
  }

}

async function getPurchasers() {
  const [data, err] = await query.getPurchasers();
  purchasers.value = data;
  data.forEach((item) => {
    purchaserCell.value.push({value: item.name + " - " + item.teamIcon, id: item.id});
  });
  if (err) {
    console.error(err);
  }

}

function timestampToDate(timestamp) {
  const date = new Date(timestamp * 1000);
  const formattedDate = date.toLocaleDateString("de-DE"); // Formatiert für deutsches Datum
  return formattedDate;
}

function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB", "TB"];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  let size = 0;
  if (i == 0) {
    size = (bytes / Math.pow(k, i)).toFixed(0);
  } else {
    size = (bytes / Math.pow(k, i)).toFixed(2);
  }
  return `${size} ${units[i]}`;
}

async function loadData() {
  let data = await query.getAsset(searchTerm.value, count.value, selectSearchOption.value, searchType.value, searchWithNumber.value);
  try {
    // Wenn das erste Element ein Array ist, dann nimm es, ansonsten gib das leere Array zurück.
    if (Array.isArray(data[0])) {
      data = data[0]; // Nimm das erste Array
    } else {
      data = []; // Falls es nicht existiert, setze ein leeres Array
    }
    if (tableData.value !== data[0].image) {
      tableData.value = data[0].image;
    }
    numberOfPictures.value = Math.ceil(data[0].numberOfImages / 100);
  } catch (e) {
    console.error(e);
  }
}

const openInPhotoshop = () => {
  let picture = pictureData.value.imgLocOrgFilepath;
  electron.openFileInPhotoshop(picture);
};

const openAndHighlightFileInFinder = () => {
  let picture = pictureData.value.imgLocOrgFilepath;
  electron.openFileInFinder(picture);
};

const startImageDownload = (event, picture) => {
  event.preventDefault(); // Standardverhalten verhindern
  let filePath = picture.imgLocOrgFilepath;
  if (filePath) {
    // Debugging
    filePath = filePath.replace(/\*/g, "%2A");
    const extension = filePath.substring(filePath.lastIndexOf('.') + 1);
    if (window?.electronAPI) {
      window.electronAPI.downloadImage(filePath, picture.imgLocProductName + "." + extension);
    }
  }
}


const onDragStart = (event, picture) => {

  event.preventDefault(); // Standardverhalten verhindern

  // check if the picture is mounted
  electron.isMountAccessible(tableData.value[0].imgLocOrgFilepath).then((result) => {
    pictureIsMounted.value = result;
  });

  let filePath = picture.imgLocOrgFilepath;
  filePath = filePath.replace(/\*/g, "%2A");


  if (window?.electronAPI) {
    window?.electronAPI.startDrag(filePath); // Drag-Aktion starten
  }
}


function onSelectionChange(rows: TableRowType[]) {

  picturesData.value = rows;
  pictureData.value = picturesData.value[picturesData.value.length - 1];

  if (pictureData.value.imgLocArticleNumber) {
    articleNumbers.value = pictureData.value.imgLocArticleNumber
        .split(',')
        .map(item => item.trim())
        .filter(item => !isNaN(item) && item !== '')
        .map(Number);
  } else {
    articleNumbers.value = ["----------"];
  }

}

function onPageStep(page: number) {
  count.value = page;
  loadData()
}

function searchWithTerm(term) {
  searchType.value = "";
  searchTerm.value = term;
  // wenn term noch nicht in searchTerms  existiert, dann   searchTerms.value.push(searchTerm.value);
  if (!searchTerms.value.includes(searchTerm.value) && searchTerms.value && searchTerm.value !== "") {
    searchTerms.value.push(searchTerm.value);
  }
  loadData();
}


const openNewArticleWindow = async (articleNumber) => {

  selectedArticleNumber.value = articleNumber;
  const [size, sizeErr] = await electron.getWindowSize("main")
  const [pos, posErr] = await electron.getWindowPosition("main")

  electron.openNewWindow("articleWindow", "http://localhost:8101/article/" + articleNumber, {
    parent: "main",
    transparent: false,
    frame: true,
    titleBarStyle: 'default',
    x: pos.x + size.width,
    y: pos.y,
  }, {
    showCustomTitlebar: false,
  });
  electron.setWindowPosition("articleWindow", pos.x + size.width, pos.y);

};

const openArticleWindow = async () => {

  const [size, sizeErr] = await electron.getWindowSize("main")
  const [pos, posErr] = await electron.getWindowPosition("main")

  let arr = []

  picturesData.value.forEach((item) => {
    arr.push(item.imgLocArticleNumber);
  });
  const uniqueNumbers = [...new Set(arr.flatMap(item => item.split(',')))];
  const articleNumber = uniqueNumbers.join(',');


  electron.openNewWindow("articleWindow", "http://localhost:8101/article/" + articleNumber, {
    parent: "main",
    transparent: false,
    frame: true,
    titleBarStyle: 'default',
    x: pos.x + size.width,
    y: pos.y,
  }, {
    showCustomTitlebar: false,
  });
  electron.setWindowPosition("articleWindow", pos.x + size.width, pos.y);

};


onMounted(async () => {

  await loadData();
  await getImportClass();
  await getPurchasers();
  electron.isMountAccessible(tableData.value[0].imgLocOrgFilepath).then((result) => {
    serverIsMounted.value = result;
  });

});


</script>